const state = () => ({
  active_section: null,
  progress: {
    about_me:       'not-started',
    my_people:      'not-started',
    my_health:      'not-started',
    my_care_wishes: 'not-started',
    my_legal_pack:  'not-started',
    my_money:       'not-started',
    my_documents:   'not-started',
    my_digital_life:'not-started',
    my_funeral_wishes: 'not-started',
    my_will_prep:   'not-started',
    my_epa_prep:    'not-started',
    my_ahd_prep:    'not-started',
  },
})

const getters = {
  get_active_section: (state) => state.active_section,
  get_progress: (state) => state.progress,
}

const mutations = {
  SET_ACTIVE_SECTION(state, section) {
    state.active_section = section
  },
  SET_SECTION_PROGRESS(state, { section, status }) {
    state.progress[section] = status
  },
}

const actions = {
  set_active_section({ commit }, section) {
    commit('SET_ACTIVE_SECTION', section)
  },
  set_section_progress({ commit }, payload) {
    commit('SET_SECTION_PROGRESS', payload)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
